"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemeProvider = exports.useStyles = exports.makeStyles = exports.useIsThemeProvided = exports.ViewPortOutOfRangeError = exports.useBrowserFontSizeFactor = exports.useWindowInnerSize = exports.useDomRect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("minimal-polyfills/Object.fromEntries");
var react_1 = require("react");
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var ScopedCssBaseline_1 = __importDefault(require("@mui/material/ScopedCssBaseline"));
var styles_1 = require("@mui/material/styles");
var styles_2 = require("@mui/material/styles");
var useWindowInnerSize_1 = require("powerhooks/useWindowInnerSize");
Object.defineProperty(exports, "useWindowInnerSize", { enumerable: true, get: function () { return useWindowInnerSize_1.useWindowInnerSize; } });
var color_1 = require("./color");
var typography_1 = require("./typography");
var color_2 = require("./color");
var shadows_1 = require("./shadows");
var useBrowserFontSizeFactor_1 = require("powerhooks/useBrowserFontSizeFactor");
Object.defineProperty(exports, "useBrowserFontSizeFactor", { enumerable: true, get: function () { return useBrowserFontSizeFactor_1.useBrowserFontSizeFactor; } });
var spacing_1 = require("./spacing");
var compat_1 = require("tss-react/compat");
var icon_1 = require("./icon");
var SplashScreen_1 = require("./SplashScreen");
var ViewPortAdapter_1 = require("powerhooks/ViewPortAdapter");
Object.defineProperty(exports, "ViewPortOutOfRangeError", { enumerable: true, get: function () { return ViewPortAdapter_1.ViewPortOutOfRangeError; } });
var memoizee_1 = __importDefault(require("memoizee"));
var id_1 = require("tsafe/id");
var breakpoints_1 = require("./breakpoints");
var capitalize_1 = require("tsafe/capitalize");
var cache_1 = __importDefault(require("@emotion/cache"));
var useGuaranteedMemo_1 = require("powerhooks/useGuaranteedMemo");
var useIsDarkModeEnabled_1 = require("./useIsDarkModeEnabled");
var useDomRect_1 = require("powerhooks/useDomRect");
Object.defineProperty(exports, "useDomRect", { enumerable: true, get: function () { return useDomRect_1.useDomRect; } });
var react_2 = require("@emotion/react");
var themeBaseContext = react_1.createContext(undefined);
var isDarkModeEnabledOverrideContext = react_1.createContext(undefined);
/** Used internally, do not export globally */
function useIsThemeProvided() {
    var theme = react_1.useContext(themeBaseContext);
    return theme !== undefined;
}
exports.useIsThemeProvided = useIsThemeProvided;
function useThemeBase() {
    var theme = react_1.useContext(themeBaseContext);
    if (theme === undefined) {
        throw new Error("Your app should be wrapped into ThemeProvider");
    }
    return theme;
}
exports.makeStyles = (_a = compat_1.createMakeStyles({
    "useTheme": useThemeBase,
}), _a.makeStyles), exports.useStyles = _a.useStyles;
function createThemeProvider(params) {
    var _a = params.palette, palette = _a === void 0 ? color_1.defaultPalette : _a, _b = params.createColorUseCases, createColorUseCases = _b === void 0 ? color_1.createDefaultColorUseCases : _b, _c = params.getTypographyDesc, getTypographyDesc = _c === void 0 ? typography_1.defaultGetTypographyDesc : _c, _d = params.isReactStrictModeEnabled, isReactStrictModeEnabled = _d === void 0 ? false : _d, _e = params.spacingConfig, spacingConfig = _e === void 0 ? spacing_1.defaultSpacingConfig : _e, defaultIsDarkModeEnabled = params.defaultIsDarkModeEnabled, _f = params.getIconSizeInPx, getIconSizeInPx = _f === void 0 ? icon_1.defaultGetIconSizeInPx : _f;
    if (defaultIsDarkModeEnabled !== undefined) {
        useIsDarkModeEnabled_1.evtIsDarkModeEnabled.state = defaultIsDarkModeEnabled;
    }
    var useTheme = (function () {
        var createTheme = memoizee_1.default(function (isDarkModeEnabled, windowInnerWidth, windowInnerHeight, browserFontSizeFactor) {
            var typographyDesc = getTypographyDesc({
                windowInnerWidth: windowInnerWidth,
                windowInnerHeight: windowInnerHeight,
                browserFontSizeFactor: browserFontSizeFactor,
            });
            var useCases = createColorUseCases({
                palette: palette,
                isDarkModeEnabled: isDarkModeEnabled,
            });
            var spacing = function (factorOrExplicitNumberOfPx) {
                return spacingConfig({
                    factorOrExplicitNumberOfPx: factorOrExplicitNumberOfPx,
                    windowInnerWidth: windowInnerWidth,
                    "rootFontSizePx": typographyDesc.rootFontSizePx,
                });
            };
            return id_1.id(__assign(__assign({ "colors": { palette: palette, useCases: useCases }, "typography": typography_1.getComputedTypography({ typographyDesc: typographyDesc }), isDarkModeEnabled: isDarkModeEnabled,
                shadows: shadows_1.shadows }, (function () {
                var muiTheme = (isReactStrictModeEnabled
                    ? styles_2.unstable_createMuiStrictModeTheme
                    : styles_2.createTheme)({
                    // https://material-ui.com/customization/palette/#using-a-color-object
                    "typography": typography_1.createMuiTypographyOptions({
                        typographyDesc: typographyDesc,
                    }),
                    "palette": color_2.createMuiPaletteOptions({
                        isDarkModeEnabled: isDarkModeEnabled,
                        palette: palette,
                        useCases: useCases,
                    }),
                    spacing: spacing,
                    "breakpoints": {
                        "values": __assign({ "xs": 0 }, breakpoints_1.breakpointsValues),
                    },
                    "components": {
                        "MuiLink": {
                            "defaultProps": {
                                "underline": "hover",
                            },
                        },
                    },
                });
                return {
                    "spacing": (function () {
                        var toFinalValue = function (value) {
                            return typeof value === "number"
                                ? spacing(value) + "px"
                                : value;
                        };
                        var out = (function (valueOrObject) {
                            if (typeof valueOrObject === "number") {
                                return spacing(valueOrObject);
                            }
                            var rightLeft = valueOrObject.rightLeft, topBottom = valueOrObject.topBottom;
                            return [
                                topBottom,
                                rightLeft,
                                topBottom,
                                rightLeft,
                            ]
                                .map(toFinalValue)
                                .join(" ");
                        });
                        var f = function (params) {
                            var axis = params.axis, kind = params.kind, value = params.value;
                            var finalValue = typeof value === "number"
                                ? spacing(value) + "px"
                                : value;
                            return Object.fromEntries((function () {
                                switch (axis) {
                                    case "horizontal":
                                        return ["left", "right"];
                                    case "vertical":
                                        return ["top", "bottom"];
                                }
                            })().map(function (direction) { return [
                                "" + kind + capitalize_1.capitalize(direction),
                                finalValue,
                            ]; }));
                        };
                        out.rightLeft = function (kind, value) {
                            return f({ "axis": "horizontal", kind: kind, value: value });
                        };
                        out.topBottom = function (kind, value) {
                            return f({ "axis": "vertical", kind: kind, value: value });
                        };
                        return out;
                    })(),
                    muiTheme: muiTheme,
                };
            })()), { "iconSizesInPxByName": icon_1.getIconSizesInPxByName({
                    getIconSizeInPx: getIconSizeInPx,
                    windowInnerWidth: windowInnerWidth,
                    "rootFontSizePx": typographyDesc.rootFontSizePx,
                }), windowInnerWidth: windowInnerWidth }));
        }, { "max": 1 });
        function useTheme() {
            var isDarkModeEnabled = useIsDarkModeEnabled_1.useIsDarkModeEnabled().isDarkModeEnabled;
            var _a = useWindowInnerSize_1.useWindowInnerSize(), windowInnerWidth = _a.windowInnerWidth, windowInnerHeight = _a.windowInnerHeight;
            var browserFontSizeFactor = useBrowserFontSizeFactor_1.useBrowserFontSizeFactor().browserFontSizeFactor;
            var isDarkModeEnabledOverride = react_1.useContext(isDarkModeEnabledOverrideContext);
            return createTheme(isDarkModeEnabledOverride !== null && isDarkModeEnabledOverride !== void 0 ? isDarkModeEnabledOverride : isDarkModeEnabled, windowInnerWidth, windowInnerHeight, browserFontSizeFactor);
        }
        return { useTheme: useTheme };
    })().useTheme;
    var SplashScreen = SplashScreen_1.createSplashScreen({ useTheme: useTheme }).SplashScreen;
    var muiCache = cache_1.default({
        "key": "mui",
        "prepend": true,
    });
    var ThemeProvider = (function () {
        function ThemeProviderWithinViewPortAdapter(props) {
            var splashScreen = props.splashScreen, children = props.children;
            var theme = useTheme();
            {
                var backgroundColor_1 = theme.colors.useCases.surfaces.background;
                react_1.useEffect(function () {
                    var _a;
                    (_a = document.querySelector("meta[name=theme-color]")) === null || _a === void 0 ? void 0 : _a.remove();
                    document.head.insertAdjacentHTML("beforeend", "<meta name=\"theme-color\" content=\"" + backgroundColor_1 + "\">");
                }, [backgroundColor_1]);
            }
            var isStoryProvider = react_1.useContext(isDarkModeEnabledOverrideContext) !== undefined;
            // prettier-ignore
            var CssBaselineOrScopedCssBaseline = useGuaranteedMemo_1.useGuaranteedMemo(function () {
                return isStoryProvider
                    ? function (_a) {
                        var children = _a.children;
                        return (jsx_runtime_1.jsx(ScopedCssBaseline_1.default, { children: children }, void 0));
                    }
                    : function (_a) {
                        var children = _a.children;
                        return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(CssBaseline_1.default, {}, void 0), children] }, void 0));
                    };
            }, [isStoryProvider]);
            // prettier-ignore
            var SplashScreenOrId = useGuaranteedMemo_1.useGuaranteedMemo(function () {
                return splashScreen === undefined ?
                    (function (_a) {
                        var children = _a.children;
                        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
                    }) :
                    (function (_a) {
                        var children = _a.children;
                        return jsx_runtime_1.jsx(SplashScreen, __assign({}, splashScreen, { children: children }), void 0);
                    });
            }, [splashScreen]);
            return (jsx_runtime_1.jsx(themeBaseContext.Provider, __assign({ value: theme }, { children: jsx_runtime_1.jsx(react_2.CacheProvider, __assign({ value: muiCache }, { children: jsx_runtime_1.jsx(styles_1.ThemeProvider, __assign({ theme: theme.muiTheme }, { children: jsx_runtime_1.jsx(CssBaselineOrScopedCssBaseline, { children: jsx_runtime_1.jsx(SplashScreenOrId, { children: children }, void 0) }, void 0) }), void 0) }), void 0) }), void 0));
        }
        function ThemeProvider(props) {
            var getViewPortConfig = props.getViewPortConfig, children = props.children, splashScreen = props.splashScreen;
            // prettier-ignore
            var ViewPortAdapterOrId = useGuaranteedMemo_1.useGuaranteedMemo(function () { return getViewPortConfig === undefined ?
                (function (_a) {
                    var children = _a.children;
                    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
                }) :
                (function (_a) {
                    var children = _a.children;
                    return jsx_runtime_1.jsx(ViewPortAdapter_1.ViewPortAdapter, __assign({ getConfig: getViewPortConfig }, { children: children }), void 0);
                }); }, [getViewPortConfig]);
            return (jsx_runtime_1.jsx(ViewPortAdapterOrId, { children: jsx_runtime_1.jsx(ThemeProviderWithinViewPortAdapter, __assign({ splashScreen: splashScreen }, { children: children }), void 0) }, void 0));
        }
        return { ThemeProvider: ThemeProvider };
    })().ThemeProvider;
    function StoryProvider(props) {
        var _a = props.dark, dark = _a === void 0 ? false : _a, children = props.children;
        return (jsx_runtime_1.jsx(isDarkModeEnabledOverrideContext.Provider, __assign({ value: dark }, { children: jsx_runtime_1.jsx(ThemeProvider, { children: children }, void 0) }), void 0));
    }
    return {
        ThemeProvider: ThemeProvider,
        useTheme: useTheme,
        StoryProvider: StoryProvider,
    };
}
exports.createThemeProvider = createThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map